import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import { breweryAndSettingsValidationSchema } from '../../validation/brewery';
import BreweryForm from '~/components/breweryForm/breweryForm';
import Spinner from '~/components/spinner/spinner';
import { actions as BreweryActions } from '~/redux/brewery';

export const geBreweryQuery = gql`
  query brewery($id: Int!) {
    brewery(id: $id) {
      id
      name
      streetAddress
      streetAddress2
      suburb
      city
      postcode
      country {
        id
        name
      }
      settings {
        licenceNumber
        transferReportAdvanceDays
        reportEmailAddress
        consolidatedLotPrefix
        defaultLotVolume
      }
    }
  }
`;

export const updateBreweryMutation = gql`
  mutation updateBrewery(
    $id: Int!
    $name: String!
    $streetAddress: String!
    $streetAddress2: String
    $suburb: String
    $city: String!
    $postcode: String!
  ) {
    updateBrewery(
      id: $id
      name: $name
      streetAddress: $streetAddress
      streetAddress2: $streetAddress2
      suburb: $suburb
      city: $city
      postcode: $postcode
    ) {
      id
      name
      streetAddress
      streetAddress2
      suburb
      city
      postcode
    }
  }
`;

export const updateSettingsMutation = gql`
  mutation updateSettings(
    $breweryId: Int!
    $reportEmailAddress: String!
    $transferReportAdvanceDays: Int!
    $licenceNumber: String
    $consolidatedLotPrefix: String
    $defaultLotVolume: Int
  ) {
    updateSettings(
      breweryId: $breweryId
      reportEmailAddress: $reportEmailAddress
      transferReportAdvanceDays: $transferReportAdvanceDays
      licenceNumber: $licenceNumber
      consolidatedLotPrefix: $consolidatedLotPrefix
      defaultLotVolume: $defaultLotVolume
    ) {
      id
    }
  }
`;

const getValuesForBrewery = ({ name, streetAddress, streetAddress2, suburb, city, postcode }, breweryId) => ({
  id: breweryId,
  name,
  streetAddress,
  streetAddress2,
  suburb,
  city,
  postcode
});

const getValuesForSettings = (
  {
    settings: { reportEmailAddress, transferReportAdvanceDays, licenceNumber, consolidatedLotPrefix, defaultLotVolume }
  },
  breweryId
) => ({
  breweryId,
  reportEmailAddress,
  transferReportAdvanceDays,
  licenceNumber,
  consolidatedLotPrefix,
  defaultLotVolume
});

const BreweryEdit = ({ brewery, history, dispatchUpdateBrewery }) => (
  <Query query={geBreweryQuery} variables={{ id: brewery.id }} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { brewery } = data;
      return (
        <div className="content">
          <Mutation mutation={updateBreweryMutation}>
            {updateBrewery => (
              <Mutation mutation={updateSettingsMutation}>
                {updateSettings => (
                  <Formik
                    initialValues={brewery}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={breweryAndSettingsValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        const breweryValues = getValuesForBrewery(values, brewery.id);
                        const settingsValues = getValuesForSettings(values, brewery.id);
                        await updateBrewery({
                          variables: breweryValues
                        });
                        await updateSettings({
                          variables: settingsValues
                        });
                        dispatchUpdateBrewery({
                          id: breweryValues.id,
                          name: breweryValues.name
                        });
                        history.push(`/settings?updated=true&name=brewery`);
                      } catch (err) {
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={BreweryForm}
                  />
                )}
              </Mutation>
            )}
          </Mutation>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      dispatchUpdateBrewery: BreweryActions.updateBrewery
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BreweryEdit));



// WEBPACK FOOTER //
// ./src/containers/breweryEdit/breweryEdit.jsx